// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"399c44b2","199":"60f6f027","310":"28e7b0ab","339":"09c51820","352":"ed7d6da0","453":"942582cb","790":"b3035c34","810":"308aa1f7"}[chunkId] + ".chunk.js";
};